$(document).ready(function () {
    function showInvoiceAlert() {
        let text = 'Diese Option kann nicht gewählt werden, da Nachw. z. steuersch. des Leistungsem. gewählt wurde und die Frist abgelaufen ist.'

        Swal.fire({
            title: 'Warnung',
            icon: 'warning',
            text: text,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
        });
    }

    $('#invoice_description').change(function (event) {
        const selectedDescription = $("#invoice_description option:selected").val();
        const srExpired = $(event.target).data('sr-expired');

        if (srExpired == 1) {
            if (selectedDescription === "closing_invoice" || selectedDescription === "partial_final_invoice") {
                showInvoiceAlert();
                $(event.target).val('');
            }
        }
    })
});
